/*
 * Copyright (c)  2021 CalAmp Corp.  All Rights Reserved
 */
import {FleetDriverScore} from '../types/reports';

/**
 * The getAuthorizationHeader function allows for initializing the configuration of the
 * Report Services.
 *
 * ```typescript
 *
 *  import {getAuthorizationHeader} from '@ion/core/src/services';
 *
 *  getAuthorizationHeader(config, sessionId);
 *
 * ```
 */

export const getAuthorizationHeader = (config, sessionId) => {
  const header = {
    Authorization         : `Bearer ${sessionId}`,
    'calamp-services-app' : config.headers['calamp-services-app'],
    'Content-Type'        : 'application/json'
  };
  return header;
};

/**
 * The getFleetDriverScorePath function is used to construct the path to the pass the driver scores as a
 * query parameter to the Jasper dashboard URL.
 *
 * ```typescript
 *
 *  import {getAuthorizationHeader} from '@ion/core/src/services';
 *
 *  const fleetScores = getFleetDriverScorePath(scores, 'qa.calamp.jasper.com');
 *
 * ```
 */
export const getFleetDriverScorePath = (fleetDriverScore: FleetDriverScore, path: string) => {
  const fleetDriverScorePath = Object.entries(fleetDriverScore).reduce((acc, [key, value]) => (
    (acc = acc + `&${key}=${value}`)
  ), path);
  return fleetDriverScorePath;
};
